var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",style:({
    width: _vm.size,
    height: _vm.size,
    fill: _vm.color || 'var(--df-primary-color)',
  }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }